import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/ebay': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M606 189.5h34l-99.2 194.8h-35.9l28.5-54.1-61.5-116.1c3.1 6.6 4.8 14.5 4.8 23.8v65.6c0 9.3 0.3 18.6 1 26.8h-29.8c-0.8-6.9-1.1-13.6-1.1-20.2-16.1 19.8-35.3 25.5-61.9 25.5-39.5 0-60.6-20.9-60.6-45 0-3.2 0.2-6.2 0.7-9-8.4 32.3-36.4 54.2-73.3 54.2-23.3 0-45.1-8.3-58.7-24.9 0 6.6-0.4 13.2-1.1 19.5h-31.5c0.5-10.2 1.1-22.8 1.1-33.1v-169.5h32.1v80.6c15.7-18.7 37.4-24.2 58.7-24.2 35.7 0 75.4 24.1 75.4 76.2 0 5.6-0.5 11-1.5 16.2 7.1-24.4 34.3-33.5 76.7-34.4 13.7-0.3 29-0.4 41.7-0.4v-3.4c0-23.4-15-33-41-33-19.3 0-33.6 8-35 21.8h-33.7c3.6-34.4 39.7-43.1 71.5-43.1 27.4 0 51.8 7 63.3 26l-10.9-20.6h37.5l54.9 109.9zM243.7 313.8c29.8 0 50.2-21.5 50.2-53.8 0-32.4-20.4-53.8-50.2-53.8-29.6 0-50.2 21.4-50.2 53.8 0 32.3 20.6 53.8 50.2 53.8zM444.6 266.5v-3.3c-11.8 0-26.3 0.1-39.4 0.6-29.1 0.9-47.2 6.2-47.2 25.3 0 12.4 9.9 25.8 35 25.8 33.7 0 51.6-18.4 51.6-48.4zM32.7 268.1c3.5 58.3 79.2 57.4 91.2 21.6h33.1c-6.4 34.4-43 46.1-74.4 46.1-57.2 0-82.5-31.5-82.5-74 0-46.8 26.2-77.6 83-77.6 45.3 0 78.4 23.7 78.4 75.4v8.5h-128.8zM127.7 246.7c-2.3-54.7-87.5-56.6-94.4 0h94.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/ebay.js
// module id = 807
// module chunks = 0